import styled, { css } from 'styled-components';
var BackToTop = styled.div.withConfig({
  displayName: "BackToTopstyles__BackToTop",
  componentId: "sc-19erwqv-0"
})(["height:60px;width:60px;border-radius:50%;position:fixed;right:15px;bottom:15px;display:flex;align-items:center;justify-content:center;cursor:none;pointer-events:none;opacity:0;visibility:hidden;z-index:", ";background:", ";border:1px solid ", ";color:", ";", " svg{fill:currentColor;display:flex;align-items:flex-end;}"], function (props) {
  return props.theme.modifier.layer['10'];
}, function (props) {
  return props.theme.color.monochrome.white;
}, function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.theme.color.palette['brand-1'];
}, function (props) {
  return props.visible && css(["visibility:visible;opacity:1;cursor:pointer;pointer-events:auto;"]);
});
export default BackToTop;